import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ activities }) => {
  const getActivityIcon = (type) => {
    const iconMap = {
      property: 'Building2',
      certificate: 'ShieldCheck',
      maintenance: 'Wrench',
      tenancy: 'Users',
      contractor: 'Briefcase',
    };
    return iconMap?.[type] || 'Activity';
  };

  const getActivityColor = (type) => {
    const colorMap = {
      property: 'var(--color-accent)',
      certificate: 'var(--color-warning)',
      maintenance: 'var(--color-error)',
      tenancy: 'var(--color-success)',
      contractor: 'var(--color-muted-foreground)',
    };
    return colorMap?.[type] || 'var(--color-foreground)';
  };

  const formatTimestamp = (timestamp) => {
    const now = new Date();
    const activityDate = new Date(timestamp);
    const diffMs = now - activityDate;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return activityDate?.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-semibold text-foreground font-heading">Recent Activity</h3>
        <button className="text-sm text-accent hover:underline font-caption">View All</button>
      </div>
      <div className="space-y-4 max-h-96 overflow-y-auto">
        {activities?.map((activity) => (
          <div key={activity?.id} className="flex items-start gap-4 p-3 rounded-lg bg-input border border-border transition-smooth hover:border-accent">
            <div className="h-10 w-10 rounded-lg flex items-center justify-center flex-shrink-0"
                 style={{ backgroundColor: `${getActivityColor(activity?.type)}15` }}>
              <Icon name={getActivityIcon(activity?.type)} size={20} color={getActivityColor(activity?.type)} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm text-foreground mb-1 font-caption">{activity?.description}</p>
              <div className="flex items-center gap-2 text-xs text-muted-foreground font-caption">
                <span>{activity?.user}</span>
                <span>•</span>
                <span>{formatTimestamp(activity?.timestamp)}</span>
              </div>
            </div>
            {activity?.badge && (
              <div className="px-2 py-1 rounded text-xs font-medium font-caption"
                   style={{ 
                     backgroundColor: `${activity?.badge?.color}15`,
                     color: activity?.badge?.color 
                   }}>
                {activity?.badge?.text}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivityFeed;